//@flow
import _ from 'lodash';
import * as React from 'react';
import { TableHeaderColumn } from 'react-bootstrap-table';
import connect from 'react-redux/es/connect/connect';
import TopoTitleComponente from '../../../components/PageTitle/TopoTitleComponente';
import ListagemPage from '../../../components/templates/ListagemPage';
import TopoListagem from '../../../components/Topo/TopoListagem';
import { objectsConstants } from '../../../_constants/objects.constants';
import { tableHelper } from '../../../_helpers/tableHelper';
import { estoqueService } from '../../../_services/estoque.service';
import EstoqueProdutosListFilter from './EstoqueProdutosListFilter';

const columns = [
  {
    path: 'produto.codigo',
    pathFilter: 'produto.codigo',
    title: 'Código',
    isKey: true,
    dataSort: true,
    className: 'column-bold',
    width: '15%',
  },
  {
    path: 'produto.nome',
    pathFilter: 'produto.nome',
    title: 'Nome do produto',
    isKey: false,
    dataSort: true,
    className: 'nomeProprio column-bold',
    width: '20%',
  },
  {
    path: 'produto.ean',
    pathFilter: 'produto.ean',
    title: 'Código EAN',
    isKey: false,
    dataSort: true,
    width: '20%',
  },

  {
    path: 'produto.fabricante.nome',
    pathFilter: 'produto.fabricante.nome',
    title: 'Fabricante',
    isKey: false,
    dataSort: true,
    width: '20%',
  },
  {
    path: 'produto.grupo.nome',
    pathFilter: 'produto.grupo.nome',
    title: 'Grupo',
    isKey: false,
    dataSort: true,
    width: '15%',
  },
  {
    path: 'produto.situacao',
    pathFilter: 'produto.situacao',
    title: 'Situação',
    isKey: false,
    dataSort: true,
    width: '10%',
  },
];

const endPoint = '/estoque-produtos/novo';
const endPointView = '/estoque-produtos/';
class EstoqueProdutosListagemPage extends React.PureComponent<{}, State> {
  constructor(props) {
    super(props);
    let fields = _.map(
      _.filter(columns, function (coluna) {
        return !coluna.notExport;
      }),
      function (coluna) {
        return coluna.path;
      }
    );
    let labels = _.map(
      _.filter(columns, function (coluna) {
        return !coluna.notExport;
      }),
      function (coluna) {
        return coluna.title;
      }
    );
    this.state = {
      labels,
      fields,
    };
  }

  handleRowClick = (row: e) => {
    this.props.history.push(endPointView + row.id);
  };

  handleNewButton = (row: e) => {
    this.props.history.push(endPoint);
  };

  render() {
    const tableColumn = _.map(columns, (column, index) => (
      <TableHeaderColumn
        key={index}
        dataField={column.path}
        dataFormat={tableHelper.renderCustom}
        formatExtraData={column}
        isKey={column.isKey}
        dataSort={column.dataSort}
        hidden={column.hidden}
        width={column.width}
        className={column.classname}
      >
        {column.title}
      </TableHeaderColumn>
    ));

    let filter = {
      extension: this.props.extension
        ? this.props.extension
        : this.props.user.extension,
    };

    return (
      <React.Fragment>
        <TopoTitleComponente
          mainTitle={objectsConstants.TITULO_ESTOQUE_PRODUTOS}
          subTitle=" "
          canBack={false}
        />
        <TopoListagem
          securityActionDo={objectsConstants.VIEW}
          securityActionOn={objectsConstants.CRUD_ESTOQUE_EDITAR}
          buttonActionClassName={'btn-light'}
          buttonAction={() => {
            this.handleNewButton();
          }}
          securityActionIcon={'icon-btn-add'}
          securityActionName={'Novo produto'}
        ></TopoListagem>
        <ListagemPage
          title={'Estoque: Produtos'}
          showNewButton={false}
          delete={() => {}}
          service={estoqueService}
          defaultOrder={'nome'}
          defaultDirection={'asc'}
          defaultFilter={filter}
          onRowClick={this.handleRowClick}
          FormFilter={EstoqueProdutosListFilter}
          controller="api/estoque"
          fields={this.state.fields}
          labels={this.state.labels}
          columns={columns}
        >
          {tableColumn}
        </ListagemPage>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { user } = state.authentication;
  return {
    user,
  };
}

export default connect(mapStateToProps)(EstoqueProdutosListagemPage);
